import { Stack } from "@mui/material";
import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { ActionFieldSimple } from "./Simple/ActionFieldSimple";
import { ActionFieldMultivalue } from "./Multivalue/ActionFieldMultivalue";

type ActionFieldQuestionsProps = {
    actionFields: ActionField[];
};

export const ActionFieldQuestions = ({ actionFields }: ActionFieldQuestionsProps) => {
    const visibleFields = actionFields.filter((field) => !field.hidden);

    if (visibleFields.length === 0) {
        return null;
    }

    const multivalueFields = visibleFields.filter((field) => field.isMultivalue);
    const simpleFields = visibleFields.filter((field) => !field.isMultivalue);

    const isMultivalueFieldPresent = multivalueFields.length > 0;

    return (
        <Stack spacing={3}>
            {isMultivalueFieldPresent && <ActionFieldMultivalue fields={multivalueFields} />}
            <Stack spacing={1.5}>
                {simpleFields.map((field) => (
                    <ActionFieldSimple key={field.id} field={field} />
                ))}
            </Stack>
        </Stack>
    );
};
